import { SingleValue } from 'react-select';

import { Select } from '../../../index';
import { Option } from '../../../types';
import { PaginationProps } from '../types';
import { GoToPage, PageSelectorContainer } from './styled';
import { getPageSelectOptions } from './utils';

const PageSelector = ({ currentPage, entriesPerPage, totalEntries, onPageChanged }: PaginationProps): JSX.Element => {
  const showedCurrentPage = currentPage + 1;
  const chosenPage: Option = { label: showedCurrentPage.toString(), value: currentPage.toString() };

  const pageSelectOptions = getPageSelectOptions(entriesPerPage, totalEntries);
  const onPageSelected = (newPage: SingleValue<Option>): void => {
    if (!newPage) return;
    onPageChanged(parseInt(newPage.value));
  };

  return (
    <PageSelectorContainer data-testid="pageSelectorContainer">
      <GoToPage>Go to page</GoToPage>
      <Select
        dataTestId="pageSelector"
        options={pageSelectOptions}
        value={chosenPage}
        isClearable={false}
        onChange={onPageSelected}
      />
    </PageSelectorContainer>
  );
};

export default PageSelector;
